<template>
  <div>
    <h1>Edit listing</h1>
    <br>
    <div id="edit-listing-form" style="overflow-x:auto;">
      <form class="create" @submit.prevent="updateListing">
        <label>Source</label>
        <input required v-model="source" type="text" placeholder="airbnb"/><br/>
        <label>City</label>
        <input required v-model="city" type="text" placeholder="New York"/><br/>
        <label>Title</label>
        <input required v-model="title" type="text" placeholder=""/><br/>
        <label>Address</label>
        <input required v-model="address" type="text" placeholder=""/><br/>
        <label># Bedrooms</label>
        <input required v-model="totalBedrooms" type="text" placeholder="1"/><br/>
        <label># Bathrooms</label>
        <input required v-model="totalBathrooms" type="text" placeholder="1"/><br/>
        <label>Summary Description</label>
        <textarea v-model="summaryDescription" type="text" placeholder=""/><br/>
        <label>Space Description</label>
        <textarea v-model="spaceDescription" type="text" placeholder=""/><br/>
        <label>Access Description</label>
        <textarea v-model="accessDescription" type="text" placeholder=""/><br/>
        <label>Guest interaction Description</label>
        <textarea v-model="guestInteractionDescription" type="text" placeholder=""/><br/>
        <label>Neighborhood Description</label>
        <textarea v-model="neighborhoodDescription" type="text" placeholder=""/><br/>
        <label>Transit Description</label>
        <textarea v-model="transitDescription" type="text" placeholder=""/><br/>
        <label>Notes Description</label>
        <textarea v-model="notesDescription" type="text" placeholder=""/><br/>
        <label>House rules Description</label>
        <textarea v-model="houseRulesDescription" type="text" placeholder=""/><br/>

        <label>Image Links</label>
        <textarea v-model="images" class="form-control" id="pictureForm" rows="4"></textarea><br>
        <label>Tags</label>
        <textarea v-model="tags" class="form-control" id="tagsForm" rows="3"></textarea><br>
        <label>Airbnb URL</label>
        <input required v-model="airbnbURL" type="text" placeholder=""/><br/>
        <label>iCal URL</label>
        <input required v-model="icalURL" type="text" placeholder=""/><br/>

        <h2>Marketplaces</h2>

        <div class="content" id="kopa-pricing">
          <input type="checkbox" :checked="this.marketplaces.includes('kopa')" name="kopa"
                 value="kopa"/>Kopa&nbsp;
          <div v-for="(month, index) in this.months" :key="index">
            {{ month }} <input v-model="kopaPricing[index]" type="text"
                               placeholder="1000"/>&nbsp;
            <label> Payout:
              ${{ getMarketplaceTakeHomePrice("kopa", kopaPricing[index]) }}</label><br>
          </div>
        </div>
        <br>

        <div class="content" id="coliving-pricing">
          <input type="checkbox" :checked="this.marketplaces.includes('coliving')" name="coliving"
                 value="coliving"/>Co-living&nbsp;
          <div v-for="(month, index) in this.months" :key="index">
            {{ month }} <input v-model="colivingPricing[index]" type="text"
                               placeholder="1000"/>&nbsp;
            <label> Payout:
              ${{ getMarketplaceTakeHomePrice("coliving", colivingPricing[index]) }}</label><br>
          </div>
        </div>
        <br>

        <div class="content" id="spareroom-pricing">
          <input type="checkbox" :checked="this.marketplaces.includes('spareroom')" name="spareroom"
                 value="spareroom"/>Spareroom&nbsp;
          <div v-for="(month, index) in this.months" :key="index">
            {{ month }} <input v-model="spareroomPricing[index]" type="text"
                               placeholder="1000"/>&nbsp;
            <label> Payout:
              ${{ getMarketplaceTakeHomePrice("spareroom", spareroomPricing[index]) }}</label><br>
          </div>
        </div>
        <br>

        <div class="content" id="nestpick-pricing">
          <input type="checkbox" :checked="this.marketplaces.includes('nestpick')" name="nestpick"
                 value="nestpick"/>Nestpick&nbsp;
          <div v-for="(month, index) in this.months" :key="index">
            {{ month }} <input v-model="nestpickPricing[index]" type="text"
                               placeholder="1000"/>&nbsp;
            <label> Payout:
              ${{ getMarketplaceTakeHomePrice("nestpick", nestpickPricing[index]) }}</label><br>
          </div>
        </div>
        <br>

        <div class="content" id="zumper-pricing">
          <input type="checkbox" :checked="this.marketplaces.includes('zumper')" name="zumper"
                 value="zumper"/>Zumper&nbsp;
          <div v-for="(month, index) in this.months" :key="index">
            {{ month }} <input v-model="zumperPricing[index]" type="text"
                               placeholder="1000"/>&nbsp;
            <label> Payout:
              ${{ getMarketplaceTakeHomePrice("zumper", zumperPricing[index]) }}</label><br>
          </div>
        </div>
        <br>
        <button type="submit">Update listing</button>
      </form>
    </div>

  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'EditListingPage',
  props: {},
  mounted() {
    this.operatorId = localStorage.getItem("userId");
    this.id = this.$route.params.id;

    axios.get(`${this.baseURL}/api/listing/${this.id}`)
        .then(res => {
          this.data = res.data;
          let listing = this.data;

          this.source = listing.source;
          this.city = listing.city;
          this.title = listing.title;
          this.address = listing.address;
          this.totalBedrooms = listing.totalBedrooms;
          this.totalBathrooms = listing.totalBaths;
          if (listing.description != null) {
            let description = listing.description;
            this.summaryDescription = (description.summaryDescription) ?
                description.summaryDescription : "";
            this.spaceDescription = (description.spaceDescription) ? description.spaceDescription : "";
            this.accessDescription = (description.accessDescription) ? description.accessDescription : "";
            this.guestInteractionDescription = (description.guestInteractionDescription) ?
                description.guestInteractionDescription : "";
            description.neighborhoodDescription = (description.neighborhoodDescription) ?
                description.neighborhoodDescription : "";
            this.transitDescription = (description.transitDescription) ?
                description.transitDescription : "";
            this.notesDescription = (description.notesDescription) ?
                description.notesDescription : "";
            this.houseRulesDescription = (description.houseRulesDescription) ?
                description.houseRulesDescription : "";
          }
          this.images = (listing.images.length > 0) ? listing.images : "";
          this.tags = (listing.tags.length > 0) ? listing.tags : "";
          this.marketplaces = listing.marketplaces;
          this.airbnbURL = listing.airBnbURL;
          this.icalURL = listing.icalURL;

          if (listing.pricing != null) {
            let pricing = listing.pricing;
            if (pricing.kopa != null) {
              this.kopaPricing = pricing.kopa;
            }
            if (pricing.coliving != null) {
              this.colivingPricing = pricing.coliving;
            }
            if (pricing.spareroom != null) {
              this.spareroomPricing = pricing.spareroom;
            }
            if (pricing.zumper != null) {
              this.zumperPricing = pricing.zumper;
            }
          }
        });
  },
  data: () => ({
    id: '',
    source: 'airbnb',
    city: 'New York',
    title: '',
    totalBedrooms: 0,
    totalBathrooms: 0,
    address: '',
    summaryDescription: '',
    spaceDescription: '',
    accessDescription: '',
    guestInteractionDescription: '',
    neighborhoodDescription: '',
    transitDescription: '',
    notesDescription: '',
    houseRulesDescription: '',
    images: '',
    tags: '',
    marketplaces: [],
    airbnbURL: '',
    icalURL: '',
    operatorId: '',
    kopaPricing: [],
    colivingPricing: [],
    spareroomPricing: [],
    nestpickPricing: [],
    zumperPricing: [],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'],
    baseURL: 'https://crossover-api-dot-elite-pointer-290612.uc.r.appspot.com'
  }),
  methods: {
    updateListing() {
      let checkboxes = document.querySelectorAll("input[type=checkbox]");
      let marketplaces = [];

      for (let i = 0; i < checkboxes.length; i++) {
        const checkbox = checkboxes[i];
        if (checkbox.checked) {
          marketplaces.push(checkbox.value);
        }
      }

      let pricing = new Map();
      for (let marketplace in marketplaces) {
        let price = [-1];
        switch (marketplaces[marketplace]) {
          case "kopa":
            price = this.kopaPricing;
            break;
          case "coliving":
            price = this.colivingPricing;
            break;
          case "spareroom":
            price = this.spareroomPricing;
            break;
          case "nestpick":
            price = this.nestpickPricing;
            break;
          case "zumper":
            price = this.zumperPricing;
            break;
        }

        pricing.set(marketplaces[marketplace], price.map(Number));
      }

      axios.put(`${this.baseURL}/api/listing/${this.id}`, {
        "id": this.id,
        "source": this.source,
        "city": this.city,
        "title": this.title,
        "address": this.address,
        "totalBedrooms": this.totalBedrooms,
        "totalBaths": this.totalBathrooms,
        "description": JSON.stringify(
            {
              "summaryDescription": this.summaryDescription,
              "spaceDescription": this.spaceDescription,
              "accessDescription": this.accessDescription,
              "guestInteractionDescription": this.guestInteractionDescription,
              "neighborhoodDescription": this.neighborhoodDescription,
              "transitDescription": this.transitDescription,
              "notesDescription": this.notesDescription,
              "houseRulesDescription": this.houseRulesDescription
            }
        ),
        "images": (typeof this.images === 'string' && this.images.length > 0) ?
            this.images.split('\n') : this.images,
        "tags": (typeof this.tags === 'string' && this.tags.length > 0) ?
            this.tags.split('\n') : this.tags,
        "marketplaces": marketplaces,
        "airBnbURL": this.airbnbURL,
        "icalURL": this.icalURL,
        "operatorId": this.operatorId,
        "pricing": JSON.stringify(Object.fromEntries(pricing)),
      }).then(() => {
        this.$router.push('/listings').catch(failure => {
          console.log(failure);
        });
      });
    },
    getMarketplaceTakeHomePrice(marketplace, price) {
      if (price === undefined) {
        return 0;
      }

      switch (marketplace) {
        case "kopa":
          return price;
        case "coliving":
          return price;
        case "spareroom":
          return price * .95;
        case "nestpick":
          return price * .94;
        case "zumper":
          return price;
        case "airbnb":
          return price * .86;
        case "anyplace":
          return price * .9;
        default:
          return -1;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

</style>
